import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import {
  withSiteMap,
  withCampaignSiteMap,
  siteMapPropType,
  processor,
  processorSet,
  Configs,
} from '@bingads-webui-campaign-react/with-site-map';
import { DetailListPageMenu } from '@bingads-webui-campaign-react/page-menu';
import { Activity, Scenario } from '@bingads-webui-react/hoc-with-signal';
import config from '@bingads-webui-component-legacy/config/index';

const dynamicPermissions = _.result(config.get('permissions'), 'dynamic', {});
const { IsRenameHotelToLodgingEnabled } = dynamicPermissions;

export const campaignPageGroups = [
  ['overview', 'recommendations', 'query-insights'],
  ['campaigns', 'adgroups'],
  ['appads-asset-groups', 'asset-groups', 'listing-groups', 'products', 'ads-and-extensions', 'assets-report', IsRenameHotelToLodgingEnabled ? 'properties' : 'hotels', 'landing-pages', 'feeds-items'],
  ['keywords', 'dsa', 'product-groups', IsRenameHotelToLodgingEnabled ? 'property-groups' : 'hotel-groups', 'audiences', 'demographics'],
  ['settings', 'locations', 'ad-schedule', 'devices'],
  ['change-history'],
  ['competition'],
  ['experiments'],
];

export const noExpandGroups = ['recommendations', 'query-insights'];

const DetailListPageMenuWithSiteMap = withCampaignSiteMap(DetailListPageMenu, _.union(processorSet.all, [processor.processPmaxCampaignPageMenu, processor.processPmaxRetailCampaignPageMenu]));

export const Loader = (props) => {
  const {
    siteMap,
    updateAvailability,
    ...others
  } = props;

  const selectedParent = _.findWhere(siteMap, { selected: true });

  useEffect(() => {
    updateAvailability(!_.isEmpty(selectedParent));
  });

  if (!props.isVisible) {
    return null;
  }

  return (
    <Scenario name="detail-list-page-memu">
      <Activity name="detail-list-page-memu">
        <DetailListPageMenuWithSiteMap pageGroups={campaignPageGroups} noExpandGroups={noExpandGroups} {...others} />
      </Activity>
    </Scenario>
  );
};

Loader.propTypes = {
  siteMap: siteMapPropType,
  updateAvailability: PropTypes.func,
  isVisible: PropTypes.bool,
};

Loader.defaultProps = {
  updateAvailability: _.noop,
  isVisible: false,
  siteMap: null,
};

const assetsDetailSiteMap = _.findWhere(Configs.standaloneSiteMap, { id: 'pmax-asset-details' });
const campaignWithAssetsSiteMap = _.union(Configs.campaignSiteMap, [assetsDetailSiteMap]);

export const CampaignPageMenuLoader = withSiteMap(
  React.memo(Loader),
  processorSet.all,
  campaignWithAssetsSiteMap
);
